import { render, staticRenderFns } from "./wangE5.vue?vue&type=template&id=08090040&"
import script from "./wangE5.vue?vue&type=script&lang=js&"
export * from "./wangE5.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports